@let node = this.resolved();
@let state = this.state();

@if (state.visible) {
  @switch (node.type) {
    @case ('text') {
      <span class="node text" [attr.data-builder-id]="node.id" [attr.style]="styles()">{{ node.text | textTranslate: language() }}</span>
    }
    @case ('data') {
      <span class="node text" [attr.data-builder-id]="node.id" [attr.style]="styles()">{{ dataText() }}</span>
    }
    @case ('image') {
      @if (image(); as image) {
        <app-image
          class="node image"
          [attr.data-builder-id]="node.id"
          [attr.style]="styles()"
          [image]="image"
          alt=""
          [objectFit]="node.style?.objectFit ?? imageDefaults.objectFit"
          [objectPosition]="node.style?.objectPosition ?? imageDefaults.objectPosition"
        />
      }
    }
    @case ('button') {
      <button
          type="button"
          class="node button"
          [attr.data-builder-id]="node.id"
          [attr.style]="styles()"
          [class.active]="state.active"
          [disabled]="state.disabled"
          [attr.aria-pressed]="action()?.type === 'service-request' ? state.active : null"
          [coreUserActivityClickTracking]="trackingName()"
          (click)="onClick($event)"
      >
        @for (child of node.children; track child.id) {
          <app-builder-node [node]="child" [pageId]="pageId()" [language]="language()" [inheritedState]="state"/>
        }
      </button>
    }
    @default {
      <span
          class="node container"
          [class.row]="node.type === 'row'"
          [class.col]="node.type === 'col'"
          [attr.data-builder-id]="node.id"
          [attr.style]="styles()"
      >
        @for (child of node.children; track child.id) {
          <app-builder-node [node]="child" [pageId]="pageId()" [language]="language()" [inheritedState]="state"/>
        }
      </span>
    }
  }
}
